import { render, staticRenderFns } from "./HumanTable.vue?vue&type=template&id=53580428&"
import script from "./HumanTable.vue?vue&type=script&lang=js&"
export * from "./HumanTable.vue?vue&type=script&lang=js&"
import style0 from "./HumanTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "HumanTable.vue"
export default component.exports